import { useEffect } from "react";
import { useGroupStore } from "@store/groupStore";
import type { LoginUser } from "@/types";
import { useAdminGroupsQuery } from "./useAdminGroupsQuery";

interface UseInitializeGroupProps {
  loginUser: LoginUser | null;
  isAdmin: boolean;
  navigate?: (path: string) => void;
}

export function useInitializeGroup({
  loginUser,
  isAdmin,
}: UseInitializeGroupProps) {
  const {
    selectedGroupId,
    setSelectedGroupId,
    selectedOfficeId,
    setSelectedOfficeId,
  } = useGroupStore();

  const { data: groups = [] } = useAdminGroupsQuery(!!loginUser && isAdmin);

  useEffect(() => {
    if (!loginUser) {
      return;
    }

    if (isAdmin) {
      if (groups.length > 0) {
        // 스토어에 저장된 그룹이 현재 목록에 유효한지 확인
        const currentValid = groups.find(
          (g: any) => g.group_id === selectedGroupId
        );

        if (currentValid) {
          // 유효하면 오피스 ID만 싱크 맞춤 (필요시)
          if (currentValid.office_id !== selectedOfficeId) {
            setSelectedOfficeId(currentValid.office_id || null);
          }
        } else {
          // 없거나 유효하지 않으면 첫 번째 그룹으로 초기화
          const initGroup = groups[0] as any;
          setSelectedGroupId(initGroup.group_id);
          setSelectedOfficeId(initGroup.office_id || null);
        }
      }
    } else {
      // 일반 유저는 본인 그룹으로 강제 설정
      if (selectedGroupId !== loginUser.group_id) {
        setSelectedGroupId(loginUser.group_id);
      }
      if (selectedOfficeId !== loginUser.office_id) {
        setSelectedOfficeId(loginUser.office_id || null);
      }
    }
  }, [
    loginUser,
    isAdmin,
    groups,
    selectedGroupId,
    selectedOfficeId,
    setSelectedGroupId,
    setSelectedOfficeId,
  ]);

  return { groups };
}
